import { Flex } from '@opendoor/bricks/core';
import { Question } from 'sellDirect/components/closingDash/disclosures/DynamicDisclosures/Question';
import {
  Prompt,
  PromptGroup,
  getSelectedOptions,
  getFollowupQuestionsForSelectedOptions,
} from 'sellDirect/helpers/closingDash/disclosures';

export interface FollowupQuestionsProps {
  question: Prompt;
  promptGroup: PromptGroup;
  showErrors?: boolean;
}

/**
 * Creates component having all possible follow up questions based on question response
 * component-test-check-ignore
 * storybook-check-ignore
 */
export const FollowupQuestions: React.FC<FollowupQuestionsProps> = ({
  question,
  promptGroup,
  showErrors,
}) => {
  const selectedOptions = getSelectedOptions(question);
  if (selectedOptions) {
    const followupQuestions = getFollowupQuestionsForSelectedOptions(
      question,
      promptGroup,
      selectedOptions,
    );

    return followupQuestions.length > 0 ? (
      <Flex backgroundColor="neutrals10" flexDirection="column" padding="16" gap="32">
        {followupQuestions.map((followupQuestion) => (
          <Question
            key={followupQuestion.id}
            question={followupQuestion}
            promptGroup={promptGroup}
            showErrors={showErrors}
          />
        ))}
      </Flex>
    ) : null;
  }
  return null;
};
